import { apiPost } from '../lib/api.ts'
import { useClearSession, useRefreshSession } from '../lib/session.ts'
import { ChangePassword } from '../routes/Security.tsx'
import { AuthLayout } from './AuthLayout.tsx'

/**
 * A password more than a year old (CCR §19012(c)(1)(C), migration 0096). The
 * account is signed in but the API answers nothing except the password change,
 * so this is the whole screen until it is done.
 */
export function PasswordExpiredScreen() {
  const refresh = useRefreshSession()
  const clear = useClearSession()
  return (
    <AuthLayout
      title="Time for a new password"
      subtitle="Your password is more than a year old. State rules for voter data require a new one at least once a year."
    >
      <ChangePassword onChanged={() => void refresh()} />
      <button
        type="button"
        className="mt-4 text-sm text-ink-muted hover:text-ink"
        onClick={async () => {
          await apiPost('/auth/logout')
          clear()
          await refresh()
        }}
      >
        Sign out instead
      </button>
    </AuthLayout>
  )
}
